import React from 'react';

export default class GuitarItem extends React.Component {
  constructor() {
    super();
    this.state = {
      item: [],
      err: null
    };
  }
  componentDidMount() {
    const { item } = this.props.location.state;
    // console.log(item);
    this.setState({ item: item });
  }
  render() {
    // console.log(this.state);
    return (
      <section className="product">
        <div className="container">
          <div className="product__breadcrumb">
            <ol className="product__breadcrumb-list">
              <li className="product__breadcrumb-item">Home</li>
              <li className="product__breadcrumb-item">Electric Guitars</li>
              <li className="product__breadcrumb-item">Stratocaster</li>
              <li className="product__breadcrumb-item">
                American Ultra Stratocaster
              </li>
            </ol>
          </div>
          <div className="product__new">New</div>
          <div className="product__name">
            <h1 className="product__name-title">
              American Ultra Stratocaster®
            </h1>
          </div>
          <div className="product__model">Model #: 0118012795</div>
          <div className="product__main">
            <div className="product__images col-8-of-12">
              <div className="product__images-main">
                <img
                  src="/images/products/guitars/american-ultra-strat/0118012795_gtr_frt_001_rr.jpg"
                  alt=""
                  srcSet
                />
              </div>
              <ul className="product__images-thumbs">
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_frt_001_rr.jpg" />
                </li>
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_back_001_rl.jpg" />
                </li>
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_cntbdyright_001_nr.jpg" />
                </li>
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_frtbdydtl_001_nr.jpg" />
                </li>
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_hdstckbck_001_nr.jpg" />
                </li>
                <li>
                  <img src="/images/products/guitars/american-ultra-strat/thumbnails/0118012795_gtr_hdstckfrt_001_nr.jpg" />
                </li>
              </ul>
            </div>
            <div className="product__infobar col-4-of-12">
              <h3 className="product__infobar-color">Color</h3>
              <ul className="product__infobar-colors">
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/natural.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/white.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/blue.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/brown.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/red.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/black.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/orange.png"
                    alt=""
                    srcSet
                  />
                </li>
              </ul>
              <h3 className="product__infobar-fingerboard">
                Fingerboard Material
              </h3>
              <ul className="product__infobar-colors">
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/natural.png"
                    alt=""
                    srcSet
                  />
                </li>
                <li className="product__infobar-color-item">
                  <img
                    src="/images/products/store/color/brown.png"
                    alt=""
                    srcSet
                  />
                </li>
              </ul>
              <div className="product__stickybar">
                <h3 className="product__stickybar-price">$3,899.00</h3>
                <a href>
                  <div className="product__stickybar-finddealer">
                    <h4>Find Dealer</h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="product__description">
            <div className="product__blurb">
              <p>
                American Ultra is our most advanced series of guitars and basses
                for discerning players who demand the ultimate in precision,
                performance and tone. The American Ultra Stratocaster features a
                unique “Modern D” neck profile with Ultra rolled fingerboard
                edges for hours of playing comfort, and the tapered neck heel
                allows easy access to the highest register. A speedy 10”-14”
                compound-radius fingerboard with 22 medium-jumbo frets means
                effortless and accurate soloing, while the Ultra Noiseless™
                Vintage pickups and advanced wiring options provide endless
                tonal possibilities – without hum. The sculpted rear body
                contours are as beautiful as they are functional and the S-1
                switch adds the neck pickup in to any switch position. This
                versatile, state-of-the-art instrument will inspire you to push
                your playing to new heights.
              </p>
              <p>
                Other features include sealed locking tuning machines, chrome
                hardware and bone nut. Includes premium molded hardshell case.
              </p>
            </div>
            <div className="product__features">
              <h3 className="product__features-title">Features</h3>
              <ul>
                <li>Alder or ash body with sculpted rear contours</li>
                <li>Three Ultra Noiseless Vintage Strat single-coil pickups</li>
                <li>“Modern D”-shaped neck with Ultra satin finish</li>
                <li>
                  10”-14” compound-radius fingerboard; 22 medium-jumbo frets
                </li>
                <li>Includes premium molded hardshell case</li>
              </ul>
            </div>
            <div className="row">
              <iframe
                width={560}
                height={315}
                src="https://www.youtube.com/embed/WURQr9IASgM"
                frameBorder={0}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="pdp-tabs">
              <ul className="pdp-tabs__nav">
                <li>
                  <a className="active" href>
                    Highlights
                  </a>
                </li>
                <li>
                  <a className href>
                    Specs
                  </a>
                </li>
                <li>
                  <a className href>
                    Support
                  </a>
                </li>
              </ul>
              <div className="pdp-tabs__content">
                <div className="pdp-tabs__panel">
                  <div className="pdp-tabs__panel-content">
                    <div className="pdp-tabs__panel-row">
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Modern_D-Neck.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            Modern "D" Neck
                          </h4>
                          <p>
                            Slim with wide shoulders, the “Modern D” neck
                            profile works for any style of playing. Ultra rolled
                            fingerboard edges and a silky, smooth Ultra satin
                            finish make the neck effortless to play.
                          </p>
                        </div>
                      </div>
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Compound-Radius2.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            10”-14” COMPOUND-RADIUS
                          </h4>
                          <p>
                            Built for speed and easy bending, the 10”-14”
                            compound-radius fingerboard is rounded near the nut
                            for chording ease, becoming increasingly flatter as
                            it nears the upper register for easy soloing.
                          </p>
                        </div>
                      </div>
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Body-Contours2.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            ENHANCED BODY CONTOURS
                          </h4>
                          <p>
                            The tapered neck heel allows unparalleled access to
                            the upper registers of the fingerboard, while the
                            sculpted rear body contour is designed for comfort.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="pdp-tabs__panel-row">
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Noiseless-Pickups2.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            ULTRA NOISELESS VINTAGE PICKUPS
                          </h4>
                          <p>
                            The Ultra Noiseless™ Vintage pickups feature true
                            classic Fender tone without hum.
                          </p>
                        </div>
                      </div>
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Electronics2.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            ADVANCED ELECTRONICS
                          </h4>
                          <p>
                            The volume knob’s S-1 switch adds the neck pickup in
                            to any switch position, while the treble bleed
                            circuit maintains your highs at any volume.
                          </p>
                        </div>
                      </div>
                      <div className="pdp-tabs__panel-item">
                        <div className="pdp-tabs__panel-item-bg">
                          <div className="pdp-tabs__panel-item-image">
                            <img src="/images/products/guitars/american-ultra-strat/pdp/AmUltra_Strat_Tuning-Machines.jpg" />
                          </div>
                          <h4 className="pdp-tabs__panel-item-title">
                            LOCKING TUNING MACHINES
                          </h4>
                          <p>
                            A high-performance feature, locking tuning machines
                            offer increased tuning stability while making string
                            changes fast and easy.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
